import { action, observable, toJS } from 'mobx';
import { api, config } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  locations: [],
  locationSid: null,
  locationData: {
    name: null,
    address1: null,
    address2: null,
    place: null,
    region: null,
    country: null,
    postalCode: null,
    locationLatitude: 0,
    locationLongitude: 0,
    notes: null,
    smokeFree: false,
    parkingInformation: null,
    hasComputerAvailable: false,
    hasPrinterAvailable: false,
    hasCopierAvailable: false,
    hasFaxAvailable: false,
    hasElevator: false,
    hasWheelchairRamp: false,
    hasAlternativeKeyboards: false,
    hasScreenEnlarger: false,
    hasScreenReader: false,
    hasSpeechRecognition: false,
    hasTextToSpeech: false,
    hasDistractionFreeRooms: false,
    timeZoneSid: 'TZ356c0b38525c4d94a1b60e76ded97066',
    currencyCode: 'USD',
    proctorLocationTypeSid: 'LT5e18eda572134379939dd2ef766ebf43'
  },
  locationAvailability: [],
  locationAvailabilityData: {
    accountSid: null,
    lateSchedulingLeadTime: 0,
    enabled: true,
    registerBlastExamGroup: null
  },
  locationTypesList: [],
  getLocationTypes: action(function() {
    api.get(`/proctors/locations/types`)
      .then(response => {
        obx.locationTypesList = response.data.results;
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  }),
  renderMap: true,
  getLocations: action(function(callback) {
    SessionStore.startLoading('Loading…', 'Locations');

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/locations`)
      .then(response => {
        SessionStore.finishLoading('Locations');
        obx.locations = response.data.results;

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  }),
  updateLocationData: action(function(data) {
    if(data.preventRender) {
      obx.renderMap = false;
    } else {
      obx.resetLocation();
    }

    for(let key in data) {
      if(data.hasOwnProperty(key)) {
        var newData = data[key];
        obx.locationData[key] = newData;
      }
    }

    // sessionStorage.setItem('registerData', JSON.stringify(obx.registerData));
  }),
  cleanData: action(function() {
    delete obx.locationData.sid;
    delete obx.locationData.proctorSid;
    delete obx.locationData.createdDate;
    delete obx.locationData.lastModifiedDate;
    delete obx.locationData.preventRender;
    delete obx.locationData.distance;
    delete obx.locationData.schedulingModule;

    if(!obx.locationData.hasScreenEnlarger) {
      obx.locationData.hasScreenEnlarger = false;
    }
  }),
  getLocation: action(function(locationSid) {
    SessionStore.startLoading('Loading…', 'Location');
    obx.resetLocation();
    obx.locationSid = locationSid;
    obx.renderMap = false;

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/locations/${locationSid}`)
      .then(response => {
        SessionStore.finishLoading('Location');
        obx.renderMap = false;
        obx.locationData = response.data;

        // Tell map to render after data is received
        obx.renderMap = true;
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  }),
  createLocation: action(function(func, component) {
    SessionStore.startLoading('Loading…', 'CreateLocation');

    obx.cleanData();

    api.post(`/proctors/${SessionStore.userData.proctorAccountSid}/locations`, obx.locationData)
      .then(response => {
        SessionStore.finishLoading('CreateLocation');
        obx.locationSid = response.data.sid;
        component.state.locationSid = obx.locationSid;
        obx.getLocationAvailability(component);
        func();
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  }),
  updateLocation: action(function(func, locationSid) {
    SessionStore.startLoading('Loading…', 'UpdateLocation');

    obx.cleanData();

    if(!obx.locationData.timeZoneSid) {
      obx.locationData.timeZoneSid = config.defaultTimeZoneSid;
    }

    api.put(`/proctors/${SessionStore.userData.proctorAccountSid}/locations/${locationSid}`, obx.locationData)
      .then(response => {
        SessionStore.finishLoading('UpdateLocation');
        func();
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  }),
  resetLocation: action(function() {
    obx.locationData.name = null;
    obx.locationData.address1 = null;
    obx.locationData.address2 = null;
    obx.locationData.place = null;
    obx.locationData.region = null;
    obx.locationData.country = null;
    obx.locationData.postalCode = null;
    obx.locationData.locationLatitude = 0;
    obx.locationData.locationLongitude = 0;
    obx.locationData.notes = null;
    obx.locationData.smokeFree = false;
    obx.locationData.parkingInformation = null;
    obx.locationData.hasComputerAvailable = false;
    obx.locationData.hasPrinterAvailable = false;
    obx.locationData.hasCopierAvailable = false;
    obx.locationData.hasFaxAvailable = false;
    obx.locationData.hasElevator = false;
    obx.locationData.hasWheelchairRamp = false;
    obx.locationData.hasAlternativeKeyboards = false;
    obx.locationData.hasScreenEnlarger = false;
    obx.locationData.hasScreenReader = false;
    obx.locationData.hasSpeechRecognition = false;
    obx.locationData.hasTextToSpeech = false;
    obx.locationData.hasDistractionFreeRooms = false;
    obx.locationData.timeZoneSid = 'TZ356c0b38525c4d94a1b60e76ded97066';
    obx.locationData.currencyCode = 'USD';
    obx.locationData.proctorLocationTypeSid = 'LT5e18eda572134379939dd2ef766ebf43';
    obx.examGroups = [];
  }),
  deleteLocation: action(function(locationSid) {
    SessionStore.startLoading('Loading…', 'DeleteLocation');

    api.delete(`/proctors/${SessionStore.userData.proctorAccountSid}/locations/${locationSid}`, obx.locationData)
      .then(response => {
        SessionStore.finishLoading('DeleteLocation');
        obx.getLocations();
      })
      .catch(error => {
        console.log(error);
        SessionStore.throwError(error)
      });
  }),
  getLocationAvailability: action(function(component) {
    SessionStore.startLoading('Loading…', 'GetLocationAvailability');

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/location/${obx.locationSid}/availability`)
      .then(response => {
        SessionStore.finishLoading('GetLocationAvailability');
        obx.locationAvailability = response.data.results;
        obx.locationAvailability.forEach(function(element) {
          // Set the default price model
          if(element.fees.length < 2 && element.fees[0].maximumSessionLength === 480) {
            element.priceModel = 'flat';
          } else {
            element.priceModel = 'tiered';
          }

          // Set the default currencies
          element.currencies = [];

          Object.keys(element.fees[0].amounts).map(
            (key) =>
            element.currencies.push(key)
          );

          // If session lengths are null, it’s a new location and we need to
          // set some defaults
          if(element.fees[0].minimumSessionLength === null) {
            element.fees[0].minimumSessionLength = 0;
            element.fees[0].maximumSessionLength = 480;
            element.fees[0].amounts = {
              USD: {
                service: 0,
                late: 0
              }
            };
            element.currencies = ['USD'];
          }

          // Set array of session lengths
          element.sessionLength = [];
          element.fees.forEach(function(sessionTime) {
            element.sessionLength.push(sessionTime.minimumSessionLength);
          });
          element.sessionLength.push(element.fees[element.fees.length - 1].maximumSessionLength);
        });

        component.setState({
          priceGroups: toJS(obx.locationAvailability)
        });
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  }),
  createLocationAvailability: action(function(sid, component) {
    SessionStore.startLoading('Loading…', 'CreateLocationAvailability');
    obx.locationAvailabilityData.accountSid = sid;

    const data = obx.locationAvailabilityData;

    if(!data.registerBlastExamGroup) {
      delete data.registerBlastExamGroup;
    }

    if(!data.registerBlastWrittenExamGroupKey) {
      delete data.registerBlastWrittenExamGroupKey;
    }

    if(!data.registerBlastHybridExamGroupKey) {
      delete data.registerBlastHybridExamGroupKey;
    }

    api.post(`/proctors/${SessionStore.userData.proctorAccountSid}/location/${obx.locationSid}/availability`, data)
      .then(response => {
        SessionStore.finishLoading('CreateLocationAvailability');

        // Set up new availability object
        obx.locationAvailability = component.state.priceGroups;
        let newAvailability = {...obx.locationAvailability[0]};
        newAvailability.sid = response.data.sid;
        newAvailability.account = {};
        newAvailability.account.sid = response.data.account.sid;
        newAvailability.account.name = response.data.account.name;
        newAvailability.fees = [toJS(newAvailability.fees[0])];
        newAvailability.fees[0].minimumSessionLength = 0;
        newAvailability.fees[0].maximumSessionLength = 480;
        newAvailability.sessionLength = [0, 480];
        newAvailability.lateSchedulingLeadTime = 0;
        obx.locationAvailability.push(newAvailability);

        component.setState({
          priceGroups: toJS(obx.locationAvailability)
        });
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  }),
  removeLocationAvailability: action(function(sid, component) {
    SessionStore.startLoading('Loading…', 'DeleteLocationAvailability');

    api.delete(`/proctors/${SessionStore.userData.proctorAccountSid}/location/${obx.locationSid}/availability/${sid}`)
      .then(response => {
        SessionStore.finishLoading('DeleteLocationAvailability');
        obx.getLocationAvailability(component);
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  }),
  toggleLocationAvailability: action(function(i) {
    obx.locationAvailability[i].enabled = !obx.locationAvailability[i].enabled;
    obx.locationAvailability[i].updated = true;
  }),
  setPriceGroupModel: action(function(i, value) {
    obx.locationAvailability[i].priceModel = value;
  }),
  updateAvailabilityData: action(function(i, data, prop) {
    obx.locationAvailability[i][prop] = data;
    obx.locationAvailability[i].updated = true;

    if(typeof data === 'object') {
      for(let key in data) {
        if(data[key]) {
          var newData = data[key];
          obx.locationAvailability[i][key] = newData;
        }
      }
    }
  }),
  updateLocationAvailability: action(function(i) {
    if(obx.locationAvailability[i].updated) {
      SessionStore.startLoading('Loading…', 'UpdateLocationAvailability');

      let payload = {};

      if(obx.locationAvailability[i].account) {
        payload.accountSid = obx.locationAvailability[i].account.sid;
      } else {
        payload.accountSid = null;
      }

      payload.lateSchedulingLeadTime = obx.locationAvailability[i].lateSchedulingLeadTime;
      payload.enabled = obx.locationAvailability[i].enabled;
      payload.cancellationPolicySid = obx.locationAvailability[i].cancellationPolicySid;

      if(obx.locationAvailability[i].registerBlastExamGroup) {
        payload.registerBlastExamGroup = obx.locationAvailability[i].registerBlastExamGroup;
      }

      if(obx.locationAvailability[i].registerBlastWrittenExamGroupKey) {
        payload.registerBlastWrittenExamGroupKey = obx.locationAvailability[i].registerBlastWrittenExamGroupKey;
      }

      if(obx.locationAvailability[i].registerBlastHybridExamGroupKey) {
        payload.registerBlastHybridExamGroupKey = obx.locationAvailability[i].registerBlastHybridExamGroupKey;
      }

      if(obx.locationAvailability[i].smarterSchedulingCalendarSid) {
        payload.smarterSchedulingCalendarSid = obx.locationAvailability[i].smarterSchedulingCalendarSid;
      }

      obx.locationAvailability[i].updated = false;

      api.put(`/proctors/${SessionStore.userData.proctorAccountSid}/location/${obx.locationSid}/availability/${obx.locationAvailability[i].sid}`, payload)
        .then(response => {
          SessionStore.finishLoading('UpdateLocationAvailability');
        })
        .catch(error => {
          SessionStore.throwError(error)
        });
    }
  }),
  updateFeeData: action(function(value, availabilityIndex, feeIndex, currency, fieldType) {
    obx.locationAvailability[availabilityIndex].fees[feeIndex].amounts[currency][fieldType] = parseInt(value, 10);
  }),
  updateFees: action(function(availabilityGroups, func) {
    SessionStore.startLoading('Loading…', 'UpdateFees');
    for(let i = 0; i < availabilityGroups.length; i++) {
      // API expects different property names than what the get API provides
      availabilityGroups[i].fees.forEach(function(element) {
        if(element.hasOwnProperty('minimumSessionLength')) {
          element.minimumLength = element.minimumSessionLength;
          element.maximumLength = element.maximumSessionLength;
          delete element.minimumSessionLength;
          delete element.maximumSessionLength;
        }
      });

      api.put(`/proctors/${SessionStore.userData.proctorAccountSid}/locations/${obx.locationSid}/availability/${obx.locationAvailability[i].sid}/fees`, availabilityGroups[i].fees)
        .then(response => {
          if(i + 1 === obx.locationAvailability.length) {
            func()
          }

          SessionStore.finishLoading('UpdateFees');

          obx.updateLocationAvailability(i);
        })
        .catch(error => {
          SessionStore.throwError(error)
        });
    }
  }),
  // Get RegisterBlast Exam Groups
  examGroups: [],
  gettingGroups: false,
  getExamGroups: action(function(locationSid){
    SessionStore.startLoading('Loading…', 'GetExamGroups');

    obx.examGroups = [];
    obx.gettingGroups = true;

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/locations/${locationSid}/registerBlast/examGroups`)
      .then(response => {
        obx.examGroups = response.data.results;
        obx.gettingGroups = false;

        // Loop through availabilities and remove any
        // exam group IDs that don't exist
        if(obx.locationAvailability && obx.locationAvailability.length > 0) {
          // Create an array of just the existing exam group IDs
          const examGroupIds = []

          obx.examGroups.forEach(examGroup => {
            examGroupIds.push(examGroup.id);
          });

          obx.locationAvailability.forEach(availability => {
            // Remove outdated registerBlastExamGroup
            if(
              availability.registerBlastExamGroup &&
              examGroupIds.indexOf(availability.registerBlastExamGroup) < 0
            ) {
              availability.registerBlastExamGroup = null;
            }

            // Remove outdated registerBlastWrittenExamGroupKey
            if(
              availability.registerBlastWrittenExamGroupKey &&
              examGroupIds.indexOf(availability.registerBlastWrittenExamGroupKey) < 0
            ) {
              availability.registerBlastWrittenExamGroupKey = null;
            }

            // Remove outdated registerBlastHybridExamGroupKey
            if(
                availability.registerBlastHybridExamGroupKey &&
                examGroupIds.indexOf(availability.registerBlastHybridExamGroupKey) < 0
            ) {
              availability.registerBlastHybridExamGroupKey = null;
            }
          });
        }

        SessionStore.finishLoading('GetExamGroups');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/LocationStore.js